if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-gallery-try-on]')) {
          const trigger = this.wristPreviewTrigger();
          if (trigger) {
            const button = event.target.closest('[data-gallery-try-on]');
            const { left, top, width, height } = button.getBoundingClientRect();
            const preview = trigger.closest('gh-wrist-preview');
            this.hide();
            preview.dispatchEvent(new CustomEvent('gh-wrist-open-from-gallery', {
              detail: { left, top, width, height }
            }));
          }
          return;
        }
        const thumbnail = event.target.closest('[data-gallery-media]');
        if (thumbnail) this.selectMedia(thumbnail.dataset.galleryMedia);
        if (event.target.closest('[data-gallery-prev]')) this.move(-1);
        if (event.target.closest('[data-gallery-next]')) this.move(1);
      });
      this.addEventListener('keydown', (event) => {
        if (!this.hasAttribute('open') || event.target.closest('video, iframe, model-viewer')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      this.addEventListener('pointerdown', (event) => {
        this.swipe = event.pointerType === 'touch' && event.isPrimary && event.target.matches('.gh-gallery__content > img')
          ? { x: event.clientX, y: event.clientY, id: event.pointerId } : null;
      });
      this.addEventListener('pointerup', (event) => {
        const swipe = this.swipe;
        this.swipe = null;
        if (!swipe || swipe.id !== event.pointerId) return;
        const x = event.clientX - swipe.x;
        const y = event.clientY - swipe.y;
        if (Math.abs(x) > 45 && Math.abs(x) > Math.abs(y) * 1.5) this.move(x < 0 ? 1 : -1);
      });
      this.addEventListener('pointercancel', () => { this.swipe = null; });
    }

    show(opener) {
      const tryOnRow = this.querySelector('[data-gallery-try-on-row]');
      const hasTryOn = Boolean(tryOnRow && this.wristPreviewTrigger());
      if (tryOnRow) tryOnRow.hidden = !hasTryOn;
      this.classList.toggle('gh-gallery--has-try-on', hasTryOn);
      super.show(opener);
      this.showActiveMedia();
    }

    wristPreviewTrigger() {
      return Array.from(document.querySelectorAll('gh-wrist-preview')).find(
        (preview) => preview.dataset.productId === this.dataset.productId
      )?.querySelector('[data-open]');
    }

    showActiveMedia() {
      this.selectMedia(this.openedBy?.getAttribute('data-media-id'));
    }

    move(direction) {
      const thumbnails = Array.from(this.querySelectorAll('[data-gallery-media]'));
      if (thumbnails.length < 2) return;
      const index = thumbnails.findIndex((item) => item.dataset.galleryMedia === this.activeMediaId);
      this.selectMedia(thumbnails[(index + direction + thumbnails.length) % thumbnails.length].dataset.galleryMedia);
    }

    selectMedia(id) {
      const content = this.querySelector('.gh-gallery__content');
      if (!content) return;
      const media = Array.from(content.children).filter((item) => item.hasAttribute('data-media-id'));
      const thumbnails = Array.from(this.querySelectorAll('[data-gallery-media]'));
      const active = media.find((item) => item.dataset.mediaId === id) || media[0];
      if (!active) return;
      if (this.activeMediaId !== active.dataset.mediaId) window.pauseAllMedia();
      this.activeMediaId = active.dataset.mediaId;
      media.forEach((item) => {
        const selected = item === active;
        item.classList.toggle('active', selected);
        item.hidden = !selected;
      });
      if (active.tagName === 'IMG') active.loading = 'eager';
      thumbnails.forEach((item) => item.setAttribute('aria-pressed', String(item.dataset.galleryMedia === this.activeMediaId)));
      const index = thumbnails.findIndex((item) => item.dataset.galleryMedia === this.activeMediaId);
      const selectedThumbnail = thumbnails[index];
      if (selectedThumbnail) {
        const rail = selectedThumbnail.parentElement;
        const left = selectedThumbnail.offsetLeft;
        if (left < rail.scrollLeft || left + selectedThumbnail.offsetWidth > rail.scrollLeft + rail.clientWidth) {
          rail.scrollLeft = left - (rail.clientWidth - selectedThumbnail.offsetWidth) / 2;
        }
      }
      const count = this.querySelector('.gh-gallery__count');
      if (count) count.textContent = `${index + 1} / ${thumbnails.length}`;
      content.scrollTop = 0;
      content.scrollLeft = 0;
      const template = active.querySelector('template');
      if (active.nodeName === 'DEFERRED-MEDIA' && template?.content.querySelector('.js-youtube')) active.loadContent(false);
    }
  });
}
